// extracted by mini-css-extract-plugin
export default {"editor":"video-service-editor_editor__FU8J9","formContainer":"video-service-editor_formContainer__nYftx"};